// extracted by mini-css-extract-plugin
module.exports = {"container":"regulations_container__ZVeNx","divider":"regulations_divider__nJEN9","header":"regulations_header__RRqto"};